import { Col, Row, Card, CardBody, CardTitle } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";

const IdentificationCard = ({ title, details, ids, listeData }) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: "10px" }}>
        {title}
      </CardTitle>
      <CardBody>
        {listeData ? listeData() : null}
        {Object.entries(details).map(([key, value], index) => (
          <Row className="mb-3" key={index}>
            <Col
              xs={12}
              md={12}
              lg={4}
              className="mb-2 col-md-4"
              style={{ whiteSpace: "nowrap" }}
            >
              {key == "Objet social" ? (
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "11em",
                      paddingTop: "18px",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              ) : (
                // : key == "Classe immobilisation" ? (
                //   <i style={{ color: "#9d9c9c" }}>
                //     <span
                //       style={{
                //         display: "inline-block",
                //         width: "11em",
                //         paddingTop: "18px",
                //       }}
                //     >
                //       {key} :
                //     </span>
                //   </i>
                // )
                <i style={{ color: "#9d9c9c" }}>
                  <span style={{ display: "inline-block", width: "11em" }}>
                    {key} :
                  </span>
                </i>
              )}
            </Col>
            <Col xs={12} md={12} lg={8} className="mb-2 col-md-8">
              <span
                style={{
                  fontFamily: "sans-serif",
                }}
              >
                {typeof value === "number" &&
                key != "Builder" &&
                key != "Port" ? (
                  renderValue(
                    value
                      .toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                      .replace("€", "")
                  )
                ) : key === "Objet social" ? (
                  <span
                    style={{
                      paddingLeft: "40px",
                      display: "flex",
                      whiteSpace: "pretty",
                    }}
                  >
                    {value}
                  </span>
                ) : key === "Comptes associés" || key === "Message" ? (
                  <span>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </span>
                ) : key == "Modèle" && ids?.publipostage_id != null ? (
                  <Link
                    to={`http://www.fluxod.com/${api}/publipostages/${ids.publipostage_id}/redirect_to_real_controller`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Partenaire" &&
                  (ids?.partenaire_id || ids?.Partenaire) != null ? (
                  <Link
                    to={`http://www.fluxod.com/${api}/partenaires/${
                      ids?.partenaire_id || ids?.Partenaire
                    }/redirect_to_real_controller`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Investisseur" && ids?.investisseur_id != null ? (
                  <Link
                    to={`${backUrl}/investisseurs/${ids.investisseur_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Impression" && ids?.impression_id != null ? (
                  <Link
                    to={`${backUrl}/impressions/${ids.impression_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "PME" && ids?.pme_id != null ? (
                  <Link
                    to={`${backUrl}/pmes/${ids.pme_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Souscription" && ids?.souscription_id != null ? (
                  <Link
                    to={`${backUrl}/souscriptions/${ids.souscription_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Réservation" && ids?.reservation_id != null ? (
                  <Link
                    to={`${backUrl}/reservations/${ids.reservation_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Projet" && ids?.projet_id != null ? (
                  <Link
                    to={`${backUrl}/projets/${ids.projet_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Partenaire" &&
                  typeof ids != "object" &&
                  ids?.includes(`${backUrl}`) ? (
                  <Link
                    to={`${ids}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Partenaire" ? (
                  <>
                    <span dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                ) : (
                  renderValue(value)
                )}
              </span>
            </Col>
          </Row>
        ))}
      </CardBody>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return "";
  } else if (
    value === "Validé" ||
    value === "Validée" ||
    value === "Finalisée" ||
    value === "Dossier de souscription CGP" ||
    value === "Dossier payé" ||
    value === "Oui"
  ) {
    return (
      <span
        className="bg-success badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else if (value === "Dossier complet") {
    return (
      <span
        className="badge"
        style={{
          fontSize: "100%",
          backgroundColor: "#33A133",
        }}
      >
        {" "}
        {value}
      </span>
    );
  } else if (value === "Dossier validé") {
    return (
      <span
        className="badge"
        style={{
          fontSize: "100%",
          backgroundColor: "#66C266",
        }}
      >
        {" "}
        {value}
      </span>
    );
  } else if (
    value === "En attente" ||
    value === "Commercialisation" ||
    value === "Optionnelle - à confirmer" ||
    value === "En cours"
  ) {
    return (
      <span className="bg-info badge bg-secondary" style={{ fontSize: "100%" }}>
        {value}
      </span>
    );
  } else if (
    value === "Ferme - en attente d'allocation" ||
    value === "Ferme - Rompu à rembourser" ||
    value === "Abandonnée" ||
    value === "Radiée" ||
    value === "Annulée" ||
    value === "Cloturée" ||
    value === "Non"
  ) {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};

export default IdentificationCard;
